import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { currentRules } from "@/data/rules";
import { DescriptionBlocks } from "./DescriptionBlocks";

export function OtherworldlyGifts() {
  const unlimited = currentRules.otherworldlyGifts.filter((g) => g.unlimited);
  const limited = currentRules.otherworldlyGifts.filter((g) => !g.unlimited);

  return (
    <RulebookPage title="Otherworldly Gifts">
      <p className="text-sm text-muted-foreground mb-3">
        For every Dark Offering you have made, you may select 1 Otherworldly
        Gift to begin the game with.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        You may accrue many more Otherworldly Gifts across the course of a game,
        by making deals and completing tasks for various Patrons you encounter.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        Some Otherworldly Gifts can be received many times, becoming more
        powerful every time. Others can only be accepted once. Choose wisely!
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 flex items-center gap-2">
        Unlimited Gifts{" "}
        <Badge variant="outline">Can be taken multiple times</Badge>
      </h2>

      {unlimited.map((gift) => (
        <Card key={gift.id} className="mb-3">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">{gift.name}</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            {gift.full_description ? (
              <DescriptionBlocks blocks={gift.full_description} />
            ) : (
              <p>{gift.description}</p>
            )}
          </CardContent>
        </Card>
      ))}

      <hr className="my-6 border-border" />

      <h2 className="text-xl font-semibold mt-6 mb-2 flex items-center gap-2">
        Limited Gifts <Badge variant="outline">Can only be taken once</Badge>
      </h2>

      {limited.map((gift) => (
        <Card key={gift.id} className="mb-3">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">{gift.name}</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            {gift.full_description ? (
              <DescriptionBlocks blocks={gift.full_description} />
            ) : (
              <p>{gift.description}</p>
            )}
          </CardContent>
        </Card>
      ))}
    </RulebookPage>
  );
}
